module.exports = __webpack_public_path__ + "static/media/Google_Ads_logo.64188783.svg";